import { DownloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { Divider, VFlex } from '@/components/base';
import ToggleRadio from '@/components/Common/ToggleRadio';
import Dropdown, { type DropdownProps } from '@/components/Dropdown/Dropdown';
import { Option } from '@/components/Select/styled';
import { MainText } from '@/components/Typography/NamedTypo';
import IconTextProperty from '@/features/Commons/Label/IconTextProperty';
import useUserRole from '@/hooks/domain/useUserRole';

import { FeedbackExport } from '../components/FeedbackExport/FeedbackExport';

type FeedbackEllipsisModalProps = {
  showFeedbackCount: boolean;
  showChart: boolean;
  onExportFeedbackListClick: (reason?: string, password?: string) => void;
  setOption: (target: any, value: boolean) => void;
  dropdownProps: DropdownProps;
};

const FeedbackEllipsisModal = ({
  dropdownProps,
  ...props
}: FeedbackEllipsisModalProps) => {
  const { isEditor } = useUserRole();

  return (
    <>
      <Dropdown {...dropdownProps}>
        <StyledWrapper>
          {isEditor && (
            <FeedbackExport onExportClick={props.onExportFeedbackListClick}>
              <Option>
                <IconTextProperty
                  icon={<DownloadOutlined />}
                  value="Export to Excel"
                />
              </Option>
            </FeedbackExport>
          )}

          <Divider style={{ margin: '4px 0' }} />
          <Option j="space-between" g="8px">
            <MainText>Chart</MainText>
            <ToggleRadio
              status={props.showChart}
              onChange={(value) => props.setOption('showChart', value)}
            />
          </Option>
          <Option j="space-between" g="8px">
            <MainText dim={!props.showChart}>Count</MainText>
            <ToggleRadio
              disabled={!props.showChart}
              status={props.showFeedbackCount}
              onChange={(value) => props.setOption('showFeedbackCount', value)}
            />
          </Option>
        </StyledWrapper>
      </Dropdown>
    </>
  );
};

export default FeedbackEllipsisModal;

const StyledWrapper = styled(VFlex)`
  padding: 4px;
  min-width: 164px;
`;
